import { render } from "./RolesFormContent.vue?vue&type=template&id=32d7fd5e"
import script from "./RolesFormContent.vue?vue&type=script&lang=js"
export * from "./RolesFormContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__